import { Stack } from "@certn/cascadia";
import { RegionContext } from "@certn/utils";
import { useTranslation } from "react-i18next";
import { PageTitle } from "../../../components/page-title/PageTitle";
import { SettingsLayout } from "../../../routes/settings/SettingsLayout";
import { MFAConfig } from "./MFAConfig";
import { DataRetentionConfig } from "./DataRetentionConfig";
import { useFlags } from "launchdarkly-react-client-sdk";
import { css } from "@emotion/css";
import { useContext } from "react";

export function SecuritySettingsPage() {
  const { t } = useTranslation();
  const { enableDataRetentionSettings, mfaEnabled } = useFlags();
  const region = useContext(RegionContext);
  const showDataRetention = enableDataRetentionSettings && region !== "au";
  return (
    <SettingsLayout>
      <div className={styles.container}>
        <Stack gap="space-6">
          <PageTitle>{t("Security")}</PageTitle>
          {mfaEnabled && <MFAConfig />}
          {showDataRetention && <DataRetentionConfig />}
        </Stack>
      </div>
    </SettingsLayout>
  );
}

const styles = {
  container: css({
    maxWidth: "900px",
  }),
};
